<template>
  <div class="form-container" v-loading.fullscreen.lock="loader">
    <div class="section-heading" align="center">CREATE TEST</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="top" >
      <el-row>
        <el-col :span="8">
          <el-form-item label="Test Name" label-position="left" prop="name">
            <el-input v-model="form.name" placeholder="Enter Test Name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :offset="1" :span="8">
          <el-form-item label="Test Type" prop="type">
            <el-select v-model="form.type"  placeholder="Select Test Type">
              <el-option label="List" value="list"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="1">
          <el-form-item label="Test Time" prop="endTime">
            <el-input v-model="form.endTime" placeholder="Enter Test Time in minutes" type="number"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="24">
          <el-form-item label="Instructions to be shown on the portal" label-position="top" prop="surveyInstructions">
            <vue-editor type="textarea" v-model="form.surveyInstructions"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <br>
    <div align="right">
      <el-button class="btn-theme" @click="createTest()">Create Test</el-button>
    </div>
    <!--     Second Component      -->
    <div id="SectionAddCon" v-show="isSurveyCreated" v-loading="loaderQue">
      <br>
      <br>
      <div class="section-heading" align="center">ADD QUESTIONS TO SECTIONS</div>
      <div  class="form-container">
        <div class="tab-container" align="center">
          <el-radio-group v-model="section">
            <el-radio-button label="Quantitative Aptitude"></el-radio-button>
            <el-radio-button label="Data Interpretation"></el-radio-button>
            <el-radio-button label="Coding Ability"></el-radio-button>
          </el-radio-group>
        </div>
        <br>
        <hr style="border:1px solid #dadde2;">
        <el-row>
        <el-col :span="16">
          <p style="font-size:18px; font-family: times new roman;">Total number of questions in this section:
            <el-tooltip class="item" effect="dark" content="Click to see question list" placement="top">
              <a style="color: #209e91; font-size:22px;text-decoration: none;" href="#" @click="ShowSectionQue()">{{FinalCount}} </a>
            </el-tooltip>
          </p>
        </el-col>
        <el-col :offset="4" :span="4">
          <el-dropdown :hide-on-click="false" @command="selectOption($event)">
            <span class="el-dropdown-link" align="right" style="color: #209e91; font-size:20px;">
              +Add Questions
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" >Add new question</el-dropdown-item>
              <el-dropdown-item command="2">Select question</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
      </div>
      <div id="SectionAdd" align="right">
        <el-button class="btn-theme" @click="createSections()">Create Sections</el-button>
      </div>
    </div>
    <!--    Question Bank Dialog Box      -->
    <el-dialog
      v-if="questionsList"
      title="Question Bank"
      :center="true"
      :visible.sync="QueBankDialog">
      <div align="right">
          <el-input v-model="searchText" style="width: 10rem; outline: none;"  placeholder="search">
            <span slot="prefix-icon=" class="el-icon-search"></span>
          </el-input>
        </div>
        <br>
      <div style="height: 60vh; overflow: auto;">
        <el-table
        :show-header="false"
        :data="filteredData"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          min-width="55">
          </el-table-column>
          <el-table-column
          align="center"
          min-width="200"
          >
          <template slot-scope="scope">
            <p v-html="scope.row.question"></p>
          </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-theme" @click="submitSectionQue()">Submit</el-button>
      </span>
    </el-dialog>
    <!--     Section Dialog Box  -->
    <el-dialog
      :center="true"
      :title="section"
      :visible.sync="SectionDialog">
      <div style="max-height: 60vh; overflow: auto;">
        <el-table
          :data="SelectedItem[sectionIndex]"
          style="width: 100%"
          :show-header="false"
          >
          <el-table-column
            type="index"
            label="Sr. No."
            min-width="50"
          >
          </el-table-column>
          <el-table-column
          align="left"
          label="Questions"
          min-width="100"
          >
          <template slot-scope="scope">
            <p v-html="scope.row.question"></p>
          </template>
          </el-table-column>
          <el-table-column
          align="left"
          min-width="20"
          >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="Remove Question" placement="top">
              <a href="#" @click="addQueBack(scope.row)"><i style="color:black;" class="el-icon-delete" ></i></a>
            </el-tooltip>
          </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-theme" @click="SectionDialog = false">Submit</el-button>
      </span>
    </el-dialog>
    <!-- Create New Question Dialog Box   -->
    <el-dialog
      :title="section"
      :visible.sync="CreateQuestionDialog"
      :center="true"
      class="dialogClass">
      <div style="height: 60vh; overflow: auto;">
        <el-form ref="form2" :model="form2" :rules="rules2" label-width="100px" label-position="top" >
          <el-row>
            <el-col :span="24">
              <el-form-item label="Question" label-position="left" prop="question">
                <vue-editor type="textarea" :rows="2" v-model="form2.question"></vue-editor>
              </el-form-item>
            </el-col>
          </el-row>
          <br>
          <div>
            <el-row>
              <div v-for="(item, key) in optionCount" :key="key">
                <el-col :span="12">
                  <el-form-item :label="optionLabel[key]" prop="options">
                    <el-input type="input" v-model="form2.options[key]" style="width:90%;display:inline-block"></el-input>
                    <i class= "el-icon-error"  v-if="optionCount > 2" @click="deleteOptions(key)" style="color: grey; display:inline-block"></i>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-button class="btn-NB" @click="addOptions()">+Add Options</el-button>
              </el-col>
            </el-row>
            <div>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="Answers" prop="correctAns">
                    <el-select v-model="form2.correctAns[0]" placeholder="Select Answer">
                      <el-option
                        v-for="(item, key) in optionCount"
                        :key="key"
                        :label="optionLabel[key]"
                        :value="key">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-theme" @click="addQuestion('form2')">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { VueEditor } from 'vue2-editor'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    VueEditor
  },
  data () {
    var validateOptions = (rule, value, callback) => {
      if (!value[0]) {
        callback(new Error('Please enter atleast two options'))
      } else if (!value[1]) {
        callback(new Error('Please enter atleast two options'))
      }
      callback()
    }
    var validateTime = (rule, value, callback) => {
      if (value === 0 || !value || value === undefined) {
        callback(new Error('Enter test duration'))
      }
      callback()
    }
    return {
      loaderQue: false,
      isQuestionListEmpty: false,
      TempQueList_getters: [],
      searchText: '',
      tempSelectedQue: [],
      TableQuestionList: [],
      createdSurveyId: '',
      createdQueId: '',
      loader: false,
      CreateQuestionValue: false,
      QueBankDialog: false,
      SectionDialog: false,
      CreateQuestionDialog: false,
      isSurveyCreated: false,
      CreatedSurvey: '',
      questionsList: [],
      SelectedQue: [[], [], []],
      checkedStatus: [],
      SelectedItem: [[], [], []],
      sectionIndex: 0,
      SectionCount: [[0], [0], [0]],
      FinalCount: 0,
      Questions: '',
      section: 'Quantitative Aptitude',
      optionCount: 2,
      optionLabel: ['Option 1', 'Option 2'],
      form: {
        name: '',
        type: '',
        desc: 'acbdefghijklmnopqrstuvwxyz',
        surveyInstructions: '',
        endTime: undefined
      },
      form2: {
        question: '',
        options: [],
        correctAns: []
      },
      rules2: {
        question: [
          { required: true, message: 'Enter Question', trigger: 'change' }
        ],
        options: [
          { validator: validateOptions, trigger: 'change' }
        ],
        correctAns: [
          { required: true, message: 'Select answer', trigger: 'change' }
        ]
      },
      rules: {
        name: [
          { required: true, message: 'Enter Test name', trigger: 'change' }
        ],
        type: [
          { required: true, message: 'Enter type', trigger: 'change' }
        ],
        surveyInstructions: [
          { required: true, message: 'Enter decription', trigger: 'change' }
        ],
        endTime: [
          { validator: validateTime, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getCreatedSurvey: 'Survey/getCreatedSurvey',
      getQuestions: 'Survey/getQuestions',
      getAddQueList: 'Survey/getAddQueList',
      getQuestion: 'Survey/getQuestion'
    }),
    filteredData () {
      return this.questionsList.filter((ele) => {
        if (ele.question === '' || ele.question === undefined) {
          return
        }
        return ele.question.toLowerCase().match(this.searchText.toLowerCase())
      })
    }
  },
  methods: {
    ...mapActions({
      createSurvey: 'Survey/createSurvey',
      fetchQuestions: 'Survey/fetchQuestions',
      addQueToSurvey: 'Survey/addQueToSurvey',
      createQuestion: 'Survey/createQuestion'
    }),
    handleSelectionChange (value) {
      console.log('Value', value)
      this.tempSelectedQue = []
      this.tempSelectedQue = value
      console.log('tempSelectedQue', this.tempSelectedQue)
      // this.addQuetoSec(this.tempSelectedQue)
    },
    validateForm (form) {
      return this.$refs[form].validate()
    },
    createSurveyDetails () {
      return this.form
    },
    createTest () {
      console.log('this Question List', this.TempQueList_getters)
      if (this.isQuestionListEmpty) {
        this.$message.error('Add questions to database')
      } else {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loader = true
            var ArrId = []
            var TempQueList = []
            TempQueList = this.TempQueList_getters
            ArrId = Object.keys(this.TempQueList_getters)
            ArrId.forEach(ele => {
              var temp = {}
              temp['id'] = ele
              temp['question'] = TempQueList[ele].Question
              this.TableQuestionList.push(temp)
            })
            this.questionsList = this.TableQuestionList
            this.isSurveyCreated = true
            if (this.isSurveyCreated) {
              this.getscrolled()
            }
            // let ht = document.body.scrollHeight + 400
            // window.scrollBy(0, ht)
            console.log('Question List=====>', this.questionsList)
          } else {
            this.isSurveyCreated = false
          }
        })
        console.log('this Question List', this.questionsList)
      }
    },
    getscrolled () {
      let ht = document.body.scrollHeight + 400
      setTimeout(() => {
        this.loader = false
        window.scrollBy(0, ht)
      }, 1000)
    },
    addSingleQuestiontoSec (item) {
      console.log('IN Single Question add', item)
      this.SelectedQue[this.sectionIndex].push(item.id)
      this.SelectedItem[this.sectionIndex].push(item)
      this.SectionCount[this.sectionIndex]++
      if (this.SectionCount[this.sectionIndex] !== 0) {
        this.FinalCount = this.SectionCount[this.sectionIndex]
      } else {
        this.FinalCount = 0
      }
      this.loader = false
    },
    addQuetoSec (item) {
      item.forEach(ele => {
        this.SelectedQue[this.sectionIndex].push(ele.id)
        this.SelectedItem[this.sectionIndex].push(ele)
        this.SectionCount[this.sectionIndex]++
        this.questionsList.forEach((element, index) => {
          if (ele.id === element.id) {
            this.questionsList.splice(index, 1)
          }
        })
      })
      if (this.SectionCount[this.sectionIndex] !== 0) {
        this.FinalCount = this.SectionCount[this.sectionIndex]
      } else {
        this.FinalCount = 0
      }
    },
    selectOption (value) {
      console.log('value', value)
      if (value === '1') {
        console.log('value', value)
        this.CreateQuestionDialog = true
      } else if (value === '2') {
        console.log('value', value)
        this.QueBankDialog = true
      }
    },
    ShowSectionQue () {
      console.log('Show Section A')
      console.log('Selected Q', this.SelectedItem)
      this.SectionDialog = true
    },
    createSections () {
      console.log('Section Count ', this.SectionCount[0][0])
      // surveyEndDate: moment(this.form.date2).format('MM/DD/YYYY'),
      // surveyStartDate: moment(this.form.date1).format('MM/DD/YYYY'),
      if (this.SectionCount[0][0] !== 0 && this.SectionCount[1][0] !== 0 && this.SectionCount[2][0] !== 0) {
        this.loader = true
        this.createSurvey({
          language: 'en',
          surveyInstructions: this.form.surveyInstructions,
          title: this.form.name,
          endTime: this.form.endTime,
          permanent: false,
          surveyType: 'list',
          note: ''
        })
      } else {
        this.$message.error('Add questions in all sections')
      }
    },
    addSections () {
      this.addQueToSurvey({
        survey_id: this.CreatedSurvey.id,
        language: 'en',
        sections: [
          {
            name: 'A',
            questions: this.SelectedQue[0]
          },
          {
            name: 'B',
            questions: this.SelectedQue[1]
          },
          {
            name: 'C',
            questions: this.SelectedQue[2]
          }
        ]
      })
    },
    addOptions () {
      this.optionLabel.push(`Option ${this.optionCount + 1}`)
      this.optionCount++
      console.log('option', this.optionLabel)
    },
    deleteOptions (key) {
      this.form2.options.splice(key, 1)
      this.optionCount--
    },
    addQuestion (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loader = true
          console.log('fomr2 corret ans', this.form2.correctAns)
          this.createQuestion({
            answerImage: '',
            comment: false,
            id: '0',
            isCommentMultimedia: false,
            isMandatory: false,
            multiChoice: false,
            Option: this.form2.options,
            Question: this.form2.question,
            questionImage: '',
            QuestionType: 'Text/Image',
            correctAnswerOptions: this.form2.correctAns,
            language: 'en'
          })
          this.CreateQuestionDialog = false
        }
      })
    },
    addQueToSection (item) {
      console.log('ADD QUE toSection', item)
      this.SelectedQue[this.sectionIndex].push(item.id)
      this.SelectedItem[this.sectionIndex].push(item.data)
      this.SectionCount[this.sectionIndex]++
      this.FinalCount = this.SectionCount[this.sectionIndex]
      this.loader = false
      console.log('SelectedQue', this.SelectedQue[this.sectionIndex])
      console.log('Selected Count', this.SectionCount[this.sectionIndex])
    },
    addQueBack (item) {
      this.SelectedItem[this.sectionIndex].forEach((ele, index) => {
        if (ele.id === item.id) {
          this.SelectedItem[this.sectionIndex].splice(index, 1)
        }
      })
      this.SelectedQue[this.sectionIndex].forEach((ele, index) => {
        if (ele.id === item.id) {
          this.SelectedQue[this.sectionIndex].splice(index, 1)
        }
      })
      this.SectionCount[this.sectionIndex]--
      if (this.SectionCount[this.sectionIndex] !== 0) {
        this.FinalCount = this.SectionCount[this.sectionIndex]
      } else {
        this.FinalCount = 0
      }
      this.questionsList.push(item)
    },
    submitSectionQue () {
      this.addQuetoSec(this.tempSelectedQue)
      this.QueBankDialog = false
    }
  },
  watch: {
    getAddQueList (val) {
      console.log('Que added', val)
      this.loader = false
      if (val.success === true) {
        this.$message.success('Survey created successfuly')
        this.$refs['form'].resetFields()
        // this.$refs['form'].resetFields()
        this.SelectedItem = [[], [], []]
        this.sectionIndex = 0
        this.SectionCount = [[0], [0], [0]]
        // this.fetchQuestions()
        this.isSurveyCreated = false
        console.log('SELETED ITEM111', this.SelectedItem)
        console.log('SELETED ITEM222', this.sectionIndex)
        console.log('SELETED ITEM333', this.SectionCount)
      } else {
        this.$message.error(val.message)
      }
    },
    getCreatedSurvey (val) {
      console.log('get created survey', val)
      this.CreatedSurvey = val
    },
    getQuestions (value) {
      console.log('======================>>>>>')
      if (value.data === null) {
        this.isQuestionListEmpty = true
        this.$message.error('Add questions to database')
      } else if (value === 'Error') {
        this.isQuestionListEmpty = false
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.isQuestionListEmpty = false
        this.TempQueList_getters = value.data
        console.log('Q details', this.TempQueList_getters)
      } else {
        this.isQuestionListEmpty = false
        this.$message.error(value.message)
      }
      this.loader = false
    },
    questionsList (value) {
      console.log('Q updated', value)
    },
    section (value) {
      console.log('section==', value)
      if (value === 'Quantitative Aptitude') {
        this.sectionIndex = 0
      } else if (value === 'Data Interpretation') {
        this.sectionIndex = 1
      } else {
        this.sectionIndex = 2
      }
      if (this.SectionCount[this.sectionIndex] !== 0) {
        this.FinalCount = this.SectionCount[this.sectionIndex]
      } else {
        this.FinalCount = 0
      }
    },
    sectionIndex (value) {
      console.log('SEction Index===', value)
    },
    checkedStatus (value) {
      console.log('checkedStatus', value)
    },
    FinalCount (value) {

    },
    CreatedSurvey (value) {
      console.log('Created Survey=====>', value)
      this.addSections()
    },
    correctAns (value) {
      console.log('correct answer', value)
    },
    getQuestion (value) {
      console.log('Question added=========>', value)
      if (value.success === true) {
        var arr = {}
        arr['id'] = value.id
        arr['question'] = value.data.Question
        this.createdQueId = value.id
        this.addSingleQuestiontoSec(arr)
        this.$refs['form2'].resetFields()
        this.optionCount = 2
        this.form2.options[0] = ''
        this.form2.options[1] = ''
        this.loader = false
        this.$message.success(value.message)
      } else {
        this.$message.error(value.message)
      }
    }
  },
  mounted () {
    this.fetchQuestions()
    this.loader = true
  }
}
</script>
<style scoped>
.surveyContainer {
  padding: 10px;
  margin: 10px;
}
.el-input__inner {
  margin-left: 0rem;
  margin-top: 5px;
}
.surveyNext {
  margin-left: 75%;
}
</style>



// WEBPACK FOOTER //
// src/components/Survey/SurveyDetails.vue